/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_checkout_title = /** @type {(inputs: {}) => string} */ () => {
	return `Objednat`
};

const da_checkout_title = /** @type {(inputs: {}) => string} */ () => {
	return `Afgiv ordre`
};

const de_checkout_title = /** @type {(inputs: {}) => string} */ () => {
	return `Bestellung aufgeben`
};

const en_checkout_title = /** @type {(inputs: {}) => string} */ () => {
	return `Checkout`
};

const es_checkout_title = /** @type {(inputs: {}) => string} */ () => {
	return `Realizar pedido`
};

const fr_checkout_title = /** @type {(inputs: {}) => string} */ () => {
	return `Passer la commande`
};

const hu_checkout_title = /** @type {(inputs: {}) => string} */ () => {
	return `Rendelés leadása`
};

const it_checkout_title = /** @type {(inputs: {}) => string} */ () => {
	return `Effettua l'ordine`
};

const nl_checkout_title = /** @type {(inputs: {}) => string} */ () => {
	return `Bestelling plaatsen`
};

const pl_checkout_title = /** @type {(inputs: {}) => string} */ () => {
	return `Złóż zamówienie`
};

const pt_checkout_title = /** @type {(inputs: {}) => string} */ () => {
	return `Finalizar pedido`
};

const sv_checkout_title = /** @type {(inputs: {}) => string} */ () => {
	return `Slutför beställning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const checkout_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.checkout_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("checkout_title", locale)
	if (locale === "cs") return cs_checkout_title(inputs)
	if (locale === "da") return da_checkout_title(inputs)
	if (locale === "de") return de_checkout_title(inputs)
	if (locale === "en") return en_checkout_title(inputs)
	if (locale === "es") return es_checkout_title(inputs)
	if (locale === "fr") return fr_checkout_title(inputs)
	if (locale === "hu") return hu_checkout_title(inputs)
	if (locale === "it") return it_checkout_title(inputs)
	if (locale === "nl") return nl_checkout_title(inputs)
	if (locale === "pl") return pl_checkout_title(inputs)
	if (locale === "pt") return pt_checkout_title(inputs)
	return sv_checkout_title(inputs)
};
export { checkout_title as "checkout.title" }